<template>
  <div>
    <b-form id="sip-setting-form" @submit.prevent="onSubmit">
      <b-form-group
        id="sip-uri-group"
        label="SIP URL"
        label-for="sip-uri"
        description="sip:user@sip-host.com"
      >
        <b-form-input
          id="sip-uri"
          v-model="sipUrl"
          type="text"
          placeholder="Enter SIP url"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="sip-password-group"
        label="SIP password"
        label-for="sip-password"
      >
        <b-form-input
          id="sip-password"
          v-model="sipPassword"
          placeholder="Enter SIP password"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="sip-ws-group"
        label="WebSocet URI"
        label-for="sip-ws"
        description="wss://server-ip:port/ws"
      >
        <b-form-input
          id="sip-wsd"
          v-model="sipWs"
          placeholder="Enter WebSocet URI"
          required
        ></b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary">Submit</b-button>
    </b-form>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'SipSettings',
  data () {
    return {
      data: [
        {
          key: 'sipUrl',
          value: '',
          user_id: this.$store.getters['auth/loggedUser'].id
        },
        {
          key: 'sipPassword',
          value: '',
          user_id: this.$store.getters['auth/loggedUser'].id
        },
        {
          key: 'sipWs',
          value: '',
          user_id: this.$store.getters['auth/loggedUser'].id
        }
      ]
    }
  },
  mounted () {
    this.$axios.get(config.baseApiUrl + '/api/users/' + this.$store.getters['auth/loggedUser'].id + '/meta')
      .then((response) => {
        response.data.data.forEach((item) => {
          this.data.forEach((it) => {
            if (it.key === item.key) {
              it.value = item.value
            }
          })
        })
      })
  },
  computed: {
    sipUrl: {
      get () {
        for (const i in this.data) {
          if (this.data[i].key === 'sipUrl') {
            return this.data[i].value
          }
        }
        return ''
      },
      set (value) {
        for (const i in this.data) {
          if (this.data[i].key === 'sipUrl') {
            this.data[i].value = value
          }
        }
      }
    },
    sipPassword: {
      get () {
        for (const i in this.data) {
          if (this.data[i].key === 'sipPassword') {
            return this.data[i].value
          }
        }
        return ''
      },
      set (value) {
        for (const i in this.data) {
          if (this.data[i].key === 'sipPassword') {
            this.data[i].value = value
          }
        }
      }
    },
    sipWs: {
      get () {
        for (const i in this.data) {
          if (this.data[i].key === 'sipWs') {
            return this.data[i].value
          }
        }
        return ''
      },
      set (value) {
        for (const i in this.data) {
          if (this.data[i].key === 'sipWs') {
            this.data[i].value = value
          }
        }
      }
    }
  },
  methods: {
    onSubmit () {
      this.$axios.post(config.baseApiUrl + '/api/users/' + this.$store.getters['auth/loggedUser'].id + '/meta', {
        meta: this.data
      })
        .then(() => {
          this.$toasted.success('Saved', {
            duration: 3000
          })
        })
    }
  }
}
</script>

<style scoped>

</style>
